import { Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy, OnInit } from "@angular/core";
import { Tax, TaxSelectionModel } from "./models/tax.model";

@Component({
    selector: "app-tax-selection",
    templateUrl: "./tax-selection-modal.component.html",
})
export class TaxSelectionModalComponent implements OnInit, OnDestroy {
    @Input({ required: true }) visible: boolean;
    @Input({ required: true }) taxes: Tax[];
    @Input() selectedTax: Tax[];

    @Output() onClose = new EventEmitter<void>();
    @Output() onApply = new EventEmitter<TaxSelectionModel>();

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["taxes"] && changes["taxes"].currentValue) {
            this.taxes = (changes["taxes"].currentValue ?? []).map((tax) => ({
                ...tax,
                taxId: tax.id,
                uId: tax.id,
                isSelected: false,
            }));
            this.taxes = this.taxes?.filter((tax) => tax?.statusId == 1); // Filter out active taxes
        }

        if (changes["selectedTax"] && changes["selectedTax"].currentValue) {
            this.selectedTax = (changes["selectedTax"].currentValue ?? []).map((tax) => ({
                ...tax,
                uId: tax.taxId ? tax.taxId : tax.id,
                isSelected: true,
            }));
        }
    }

    ngOnDestroy(): void {}

    applyTax(): void {
        const taxSelection: TaxSelectionModel = {
            selectedTaxes: this.selectedTax,
        };
        this.onApply.emit(taxSelection);
    }

    onCloseDialog(): void {
        this.visible = false;
        this.selectedTax = [];
        this.onClose.emit();
    }
}
